import { render, staticRenderFns } from "./mappingManage.vue?vue&type=template&id=30a80d4d&scoped=true"
import script from "./mappingManage.vue?vue&type=script&lang=js"
export * from "./mappingManage.vue?vue&type=script&lang=js"
import style0 from "./mappingManage.vue?vue&type=style&index=0&id=30a80d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a80d4d",
  null
  
)

export default component.exports